import React from 'react';
import ReceiptItem from 'components/common/receipt/receipt_item';
import CaTaxReceiptItem from 'components/common/receipt/ca_tax_receipt_item';
import { toDinero } from 'utilities/currency';
import { getCountryCode } from 'utilities/locales';

/**
 * use this if you need only line item or shipment taxes for a particular order
 * overrides are available for label for non-CA countries
 * defaults to line_item if no input
 */
const CustomTaxReceiptItem = (props) => {
  const { orderData, taxType = 'line_item', label } = props;

  if (getCountryCode() === 'ca') {
    return <CaTaxReceiptItem orderData={orderData} taxType={taxType} />;
  }

  const taxes = orderData.tax_breakdown.filter(
    (t) => !taxType || (taxType && t.type === taxType),
  );

  if (taxes.length === 0) {
    return null;
  }

  // ex: if order has 2 items, it will have 2 tax blobs with line_item type, so we
  // need to reduce it to a single element
  const singleTax = taxes.reduce((prev, current) => {
    return {
      ...current,
      amount: toDinero(current.amount).add(toDinero(prev.amount)).toUnit(),
    };
  });

  return (
    <ReceiptItem
      label={label || singleTax.label}
      cost={singleTax.amount}
      currency={singleTax.currency}
      isTax={true}
    />
  );
};

export default CustomTaxReceiptItem;
